<template>
  <div>
    <div
      class="text-left"
      :style="
        message && message.actor === 'question' ? 'display: flex; justify-content: flex-end' : ''
      "
    >
      <div
        class="bubble"
        style="padding: 7px"
        v-if="message.type == 'text'"
        :style="{ 'background-color': background, color: color }"
        :class="{ 'link-white': color && (color == 'white' || color.toLowerCase() == '#ffffff') }"
      >
        <specialtext :text="message.text"></specialtext>
      </div>
      <div class="bubble" v-else-if="message.type == 'button'">
        <div
          class="message"
          v-if="
            (message.text != '' && message.type == 'text') ||
            (message.type == 'button' && (message.buttons.length > 0 || message.text != ''))
          "
          style="
            width: 100%;
            word-break: break-word;
            position: relative;
            border-radius: 12px;
            max-width: 300px;
            overflow-wrap: break-word;
            min-height: 22px;
            min-width: 14px;
            line-height: 15.36px;
            overflow: hidden;

            white-space: initial;
          "
          :style="{ float: align }"
        >
          <div
            style="font-size: 12px"
            :style="{ color: color }"
            :class="{
              'link-white': color && (color == 'white' || color.toLowerCase() == '#ffffff')
            }"
          >
            <div style="padding: 5px 8px 6px" :style="{ 'background-color': background }">
              <span style="line-height: 15.36px; line-height: 22px">
                <template v-if="message.text != ''">
                  <specialtext :text="message.text"></specialtext>
                </template>
                <template v-else>-</template>
              </span>
            </div>
          </div>
          <div
            v-if="message.buttons && message.buttons.length > 0"
            style="width: 100%; background-color: #e7e7e7; overflow: hidden"
            :style="{ float: align }"
          >
            <div style="margin-bottom: 0px" class="py-2">
              <div
                class="py-1"
                style="border-radius: 0px; text-align: center; padding: 2px 15px"
                v-for="(button, bindex) in message.buttons"
                :key="bindex"
              >
                <template v-if="button">
                  <span style="color: #0084ff">
                    <v-btn
                      v-if="button.type == 'web_url'"
                      block
                      depressed
                      style="font-weight: bold; border-radius: 7px"
                      :href="updateQueryString(button.url, 'from', 'livechat')"
                      target="_blank"
                      rel="noopener noreferrer"
                      >{{ button.title | truncate(20) }}
                    </v-btn>

                    <template v-else>
                      <v-btn
                        @click="clickActionButton(button)"
                        block
                        depressed
                        style="font-weight: bold; border-radius: 7px"
                      >
                        {{ button.title | truncate(20) }}
                      </v-btn>
                    </template>
                  </span>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bubble" v-else-if="message.type == 'image'">
        <div
          @click="showImg(message.image_url)"
          style="max-width: 200px; cursor: pointer"
          class="pa-2"
        >
          <v-img :src="message.image_url"></v-img>
        </div>
      </div>
      <div class="bubble" v-else-if="message.type == 'video'">
        <div style="max-width: 300px" class="pa-2">
          <video style="border-radius: 10px" width="100%" height="100%" controls>
            <source :src="message.source" type="video/mp4" />
            <source :src="message.source" type="video/ogg" />
          </video>
          <v-img :src="message.image_url"></v-img>
        </div>
      </div>

      <perfect-scrollbar
        v-if="message.type == 'generic'"
        :style="`width: 100% overflow: auto`"
        class="pb-5"
      >
        <div style="display: flex; flex-direction: row">
          <v-card
            style="width: 200px; background-color: rgb(231, 231, 231)"
            class="mr-2"
            v-for="(genericitem, k) in message.data"
            :key="k"
          >
            <div
              style="
                display: flex;
                height: 100%;
                flex-direction: column;
                justify-content: space-between;
              "
            >
              <div>
                <div>
                  <div v-if="genericitem.image_url">
                    <v-img
                      @click="showImg(genericitem.image_url)"
                      style="cursor: pointer"
                      width="200px"
                      :src="genericitem.image_url"
                    ></v-img>
                  </div>
                </div>
                <div style="width: 200px"></div>
                <div class="px-1">
                  <div class="px-3 pt-2">
                    <div style="font-weight: bold; text-align: left; font-size: 13px">
                      {{ genericitem.title }}
                    </div>
                    <div
                      style="
                        font-weight: light;
                        font-size: 13px;
                        text-align: left;
                        line-height: 15px;
                        color: #7b7b7b;
                      "
                    >
                      {{ genericitem.subtitle }}
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="genericitem.buttons && genericitem.buttons.length > 0"
                style="width: 100%; background-color: #e7e7e7"
              >
                <div style="margin-bottom: 0px" class="py-2">
                  <div
                    class="py-1"
                    style="border-radius: 0px; text-align: center; padding: 2px 15px"
                    v-for="(button, bindex) in genericitem.buttons"
                    :key="bindex"
                  >
                    <template v-if="button">
                      <span style="color: #0084ff">
                        <v-btn
                          v-if="button.type == 'web_url'"
                          block
                          depressed
                          style="font-weight: bold; border-radius: 7px"
                          :href="updateQueryString(button.url, 'from', 'livechat')"
                          target="_blank"
                          rel="noopener noreferrer"
                          >{{ button.title | truncate(20) }}
                        </v-btn>

                        <template v-else>
                          <v-btn
                            @click="clickActionButton(button)"
                            block
                            depressed
                            style="font-weight: bold; border-radius: 7px"
                          >
                            {{ button.title | truncate(20) }}
                          </v-btn>
                        </template>
                      </span>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </div>
      </perfect-scrollbar>
      <div>
        <v-dialog v-model="showImage" width="600px">
          <v-card style="position: relative" v-if="currentImg" class="pa-3">
            <v-img :src="currentImg"></v-img>
            <div style="position: absolute; right: 10px; top: 10px">
              <v-btn @click="showImage = false" small icon color="red" depressed>
                <v-icon small color="white">close</v-icon>
              </v-btn>
            </div>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import specialtext from '@/components/Specialtext.vue'
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'

export default {
  props: {
    message: [Object, String, Array],
    background: {
      type: String,
      default: '#F1F0F0'
    },
    color: {
      type: String,
      default: 'black'
    },
    showDeep: {
      type: Boolean,
      default: true
    },
    size: {
      default: 'big'
    },
    showProfile: {
      default: false,
      type: Boolean
    },
    align: {
      default: 'left'
    }
  },
  data() {
    return {
      showImage: false,
      currentImg: ''
    }
  },
  components: {
    specialtext,
    PerfectScrollbar
  },
  computed: {
    lg() {
      return this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl
    }
  },
  methods: {
    showImg(img) {
      this.showImage = true
      this.currentImg = img
    },
    clickActionButton(button) {
      this.$emit('sendMessage', {
        title: button.title,
        payload: button.payload
      })
    },
    goLinkBtn(link) {
      window.location.assign(link)
    },
    updateQueryString(uri, key, value) {
      var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i')
      var separator = uri.indexOf('?') != -1 ? '&' : '?'
      if (uri.match(re)) {
        return uri.replace(re, '$1' + key + '=' + value + '$2')
      } else {
        return uri + separator + key + '=' + value
      }
    },
    onCopy: function () {
      let vm = this

      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 3000)
    },
    onCopyError: function () {}
  }
}
</script>

<style lang="scss">
.bubble {
  word-break: break-word;
  border-radius: 12px;

  font-size: 14px;
  display: inline-block;
  background-color: #efefef;
  white-space: pre-wrap;
}
.list-group.vertical-steps > .list-group-item {
  border: none;
  border-left: 3px solid #ece5dd;
  box-sizing: border-box;
  border-radius: 0;
  counter-increment: step-counter;
  padding-left: 40px;
  padding-right: 0px;
  padding-bottom: 50px;
  padding-top: 0px;
  margin-top: -25px;

  &:first-child {
    margin-top: 0;
  }
}

.link-white a {
  color: white !important;
}
</style>
